export class Option {
    constructor(public value: string, public name: string) { }
}



// WEBPACK FOOTER //
// ./app/components/model-bindings/option.ts